import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navItems } from '@/mocks/home';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const isActive = (path: string) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <>
      <header
        className={`sticky top-0 z-50 w-full border-b bg-primary-50/95 backdrop-blur transition-all duration-300 ${
          scrolled
            ? 'border-primary-100 shadow-[0_10px_24px_-18px_oklch(var(--primary-900)/0.45)]'
            : 'border-transparent shadow-none'
        }`}
      >
        <div className="mx-auto flex h-16 md:h-[72px] w-full items-center justify-between gap-3 px-4 md:px-6 lg:px-6 xl:px-10">
          <Link to="/" className="flex shrink-0 items-center group">
            <img
              src="/logo.png"
              alt="Forex Academy Thailand"
              width={180}
              height={60}
              className="h-auto w-[180px]"
            />
          </Link>

          <nav aria-label="เมนูหลัก" className="hidden lg:flex flex-1 items-center justify-center gap-2 xl:gap-4 2xl:gap-5">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`group relative flex items-center whitespace-nowrap rounded-lg px-3 py-2 text-[13px] font-medium transition-colors xl:px-4 xl:text-sm ${
                  isActive(item.path)
                    ? 'text-primary-700'
                    : 'text-foreground-600 hover:bg-primary-100 hover:text-primary-700'
                }`}
              >
                <span className="relative">
                  {item.label}
                  <span
                    className={`pointer-events-none absolute -bottom-1.5 left-0 right-0 h-[2px] rounded-full bg-primary-500 transition-all duration-300 ${
                      isActive(item.path)
                        ? 'scale-x-100 opacity-100'
                        : 'scale-x-0 opacity-0 group-hover:scale-x-100 group-hover:opacity-40'
                    }`}
                  />
                </span>
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/forex-trading#brokers"
              className={`group flex shrink-0 cursor-pointer items-center whitespace-nowrap rounded-md bg-primary-500 font-medium text-background-50 transition-all duration-300 hover:bg-primary-600 ${
                scrolled ? 'gap-1 px-2.5 py-1.5 text-[12px]' : 'gap-1.5 px-3 py-2 text-[13px] md:px-4'
              }`}
            >
              <i
                className={`ri-user-add-line transition-all duration-300 ${
                  scrolled ? 'text-sm' : 'text-base'
                }`}
              />
              เปิดบัญชี
              <i
                className={`ri-arrow-right-line transition-all duration-300 group-hover:translate-x-0.5 ${
                  scrolled ? 'text-[10px] opacity-60' : 'text-xs opacity-70'
                }`}
              />
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
              aria-label="เมนู"
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t border-primary-100 bg-primary-50 px-4 pb-5 pt-3">
            <nav aria-label="เมนูหลัก" className="flex flex-col gap-0.5">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMenuOpen(false)}
                  className={`group flex items-center rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive(item.path)
                      ? 'text-primary-700'
                      : 'text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
                  }`}
                >
                  <span className="relative">
                    {item.label}
                    <span
                      className={`pointer-events-none absolute -bottom-1 left-0 right-0 h-[2px] rounded-full bg-primary-500 transition-all duration-300 ${
                        isActive(item.path)
                          ? 'scale-x-100 opacity-100'
                          : 'scale-x-0 opacity-0 group-hover:scale-x-100 group-hover:opacity-40'
                      }`}
                    />
                  </span>
                </Link>
              ))}
            </nav>

            <Link
              to="/forex-trading#brokers"
              onClick={() => setMenuOpen(false)}
              className="mt-3 flex items-center justify-between gap-2 rounded-md bg-primary-500 px-3 py-3 text-sm font-medium text-background-50"
            >
              <span className="flex items-center gap-2">
                <i className="ri-user-add-line text-base" />
                เปิดบัญชี
              </span>
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        )}
      </header>

    </>
  );
}